export default "__VITE_ASSET__w4f8itRa__"